<template>
  <div v-if="product && productPrice" class="f-col items-start gap-4">
    <component
      :is="isPageTitle ? 'h1' : 'div'"
      ref="productDetailsTitleRef"
      :aria-level="isPageTitle ? undefined : 1"
      class="subtitle-3"
      data-test-id="product-name"
      :role="isPageTitle ? undefined : 'heading'"
    >
      {{ product.name }}
    </component>
    <p v-if="$feature.showShortDescriptionOnPDP && product.shortDescription" class="body-4">
      {{ product.shortDescription }}
    </p>
  </div>
</template>

<script lang="ts" setup>
const { isPageTitle = true } = defineProps<{
  isPageTitle?: boolean
}>()

const { product, productPrice } = usePdp()

// Do not remove: shared with StickyCtaBar, which measures the PDP title position to decide when the sticky title should appear.
const productDetailsTitleRef = useState<HTMLElement>('productDetailsTitleRef')
</script>
